import { chakra } from '@plurall/elo-v3';

import {
  simpleBarChartLegendItemRecipe,
  simpleBarChartLegendLineRecipe,
  simpleBarChartLegendRecipe,
  simpleBarChartRootRecipe,
  simpleBarChartStageRecipe,
  simpleBarChartTooltipDotRecipe,
  simpleBarChartTooltipLabelRecipe,
  simpleBarChartTooltipRecipe,
  simpleBarChartTooltipRowRecipe,
  simpleBarChartTooltipTitleRecipe,
  simpleBarChartTooltipValueRecipe,
  simpleBarChartViewportRecipe,
} from './SimpleBarChart.recipe';

export const SimpleBarChartRootFactory = chakra('div', simpleBarChartRootRecipe);
export const SimpleBarChartViewportFactory = chakra('div', simpleBarChartViewportRecipe);
export const SimpleBarChartStageFactory = chakra('div', simpleBarChartStageRecipe);
export const SimpleBarChartLegendFactory = chakra('div', simpleBarChartLegendRecipe);
export const SimpleBarChartLegendItemFactory = chakra('span', simpleBarChartLegendItemRecipe);
export const SimpleBarChartLegendLineFactory = chakra('span', simpleBarChartLegendLineRecipe);
export const SimpleBarChartTooltipFactory = chakra('div', simpleBarChartTooltipRecipe);
export const SimpleBarChartTooltipTitleFactory = chakra('p', simpleBarChartTooltipTitleRecipe);
export const SimpleBarChartTooltipRowFactory = chakra('div', simpleBarChartTooltipRowRecipe);
export const SimpleBarChartTooltipLabelFactory = chakra('span', simpleBarChartTooltipLabelRecipe);
export const SimpleBarChartTooltipDotFactory = chakra('span', simpleBarChartTooltipDotRecipe);
export const SimpleBarChartTooltipValueFactory = chakra('strong', simpleBarChartTooltipValueRecipe);
